import {HiveChartSection} from "features/hive";
import {useEffect} from "react";
import {usePageTitleStore} from "entities/pageTitle";
import {useBreadcrumbsStore} from "entities/breadcrumbs";
import {useParams} from "react-router-dom";

type ChartId = "apiaryhappiness" | "apiarytemperature" | "apiaryhumidity" | "apiaryco2" | "apiaryweight" | "apiarystate";
// eslint-disable-next-line
export const CHARTS: { id: ChartId; name: string }[] = [
    { id: "apiaryhappiness", name: "Индекс счастья" },
    { id: "apiarytemperature", name: "Температура" },
    { id: "apiaryhumidity", name: "Влажность" },
    { id: "apiaryco2", name: "CO₂" },
    { id: "apiaryweight", name: "Масса улья" },
    { id: "apiarystate", name: "Состояние семьи" },
];

export const ChartPage = () => {
    const setTitle = usePageTitleStore(s => s.setDynamicTitle)
    const setBreadcrumbs = useBreadcrumbsStore(s => s.setCrumbs)
    const resetBreadcrumbs = useBreadcrumbsStore(s => s.resetCrumbs)

    const {chartId} = useParams<{chartId?: string}>()

    useEffect(() => {
        const currentChartName = CHARTS.filter((el) => el.id === (chartId || ""))[0].name || "График";

        setTitle(currentChartName)
        setBreadcrumbs([
            {
                title: "Моя пасека",
                url: "/",
                route: {
                    path: "/"
                }
            },
            {
                title: currentChartName,
                url: "/",
                route: {
                    path: "/"
                }
            }
        ])
        return () => {
            setTitle("")
            resetBreadcrumbs()
        }
    }, [])

    return (
        <HiveChartSection
            isApiary={true}
            hideMarksAndThresholds={true}
        />
    );
};

